// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A3CH","content":"styles_content__WD86C","tableWrap":"styles_tableWrap__28Sgz"};